import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { gridConfig, gridContainerConfig } from './grid-config';

const { forwardRef } = React;

const propTypes = {
	dataTestId: PropTypes.string,
};
const defaultProps = {
	dataTestId: null,
};

const StyledComponent = styled.div`
	column-gap: ${gridConfig.xxs.gutter};
    display: grid;
	grid-template-columns: repeat(12, 1fr);
	margin: 0 0 ${gridConfig.xxs.gutter};
	&:last-child {
		margin: 0;
	}
    max-width: ${gridContainerConfig.maxWidth};
	row-gap: ${gridConfig.xxs.gutter};
    width: 100%;

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		margin:0 0 ${gridConfig.m.gutter}
        &:last-child {
            margin: 0;
        }

		column-gap: ${gridConfig.m.gutter};
		row-gap: ${gridConfig.m.gutter};
	}

	@media screen and (min-width: ${gridConfig.xl.minWidth}) {
		column-gap: ${gridConfig.xl.gutter};
		row-gap: ${gridConfig.xl.gutter};
	}
`;

const GridRow = forwardRef(({ dataTestId, ...props }, ref) => (
	<StyledComponent
		className="fuse-responsive-grid__row"
		data-test-id={dataTestId}
		ref={ref}
		{...props}
	/>
));

GridRow.propTypes = propTypes;
GridRow.defaultProps = defaultProps;
GridRow.displayName = 'GridRow';

export default GridRow;
